import React from 'react';
import styled from 'styled-components';
export const StyledBadge = styled.div `
  position: absolute;
  bottom: 0;
  right: -8px;
`;
const sizesMappingWithoutIcon = {
    120: 40,
    96: 32,
    88: 28,
    80: 24,
    72: 24,
    64: 20,
    56: 20,
    48: 16,
    40: 16,
    32: 14,
    24: 12,
    20: 10,
    16: 8,
};
const sizesMapping = {
    120: 40,
    96: 32,
    88: 28,
    80: 28,
    72: 28,
    64: 24,
    56: 24,
    48: 24,
    40: 20,
    32: 20,
    24: 16,
    20: 14,
    16: 10,
};
export const SuperEllipseBadge = ({ badge, size }) => {
    if (!badge) {
        return null;
    }
    return (React.createElement(StyledBadge, null, React.cloneElement(badge, {
        size: badge.props.icon || badge.props.image
            ? sizesMapping[size]
            : sizesMappingWithoutIcon[size],
    })));
};
